import { invoice as invoiceResource } from 'utilities/api';
import { InvoiceDetails } from '../types';

/** Cancellable axios result returned by the generated `invoice` resource. */
export interface ApiResult<T> {
  promise: Promise<{ data: T }>;
  cancel: () => void;
}

/**
 * Typed view of the subset of the generated `invoice` axios resource the
 * redesign uses. The resource is exported untyped (`Object`) from
 * `utilities/api`; this narrows it for the TypeScript redesign files without
 * touching the shared JS module.
 */
export interface InvoiceApiResource {
  fetch: (id: string) => ApiResult<InvoiceDetails>;
  delete: (id: string) => ApiResult<unknown>;
  update: (id: string, body: unknown) => ApiResult<unknown>;
  create: (body: unknown) => ApiResult<unknown>;
}

const invoiceApi = (invoiceResource as unknown) as InvoiceApiResource;

export default invoiceApi;
